import background from "assets/images/backgroundRotated.png";
import theme from "assets/theme";
import React, { useContext, useState } from "react";
import {
  Image,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import AuthService from "services/Auth.service";
import {
  SCREEN_ADMIN_FORGOT,
  SCREEN_ADMIN_REGISTER,
  SCREEN_PRIVACY,
} from "web/constants";
import { ToastContext } from "web/context/Toast.context";
import SelectOrganizationModal from "webComponentsAuth/SelectOrganizationModal.component";
import CustomLink from "webComponentsFormElements/CustomLink.component";
import Overlay from "webComponentsFormElements/Overlay.component";
import LabelInput from "webComponentsFormElements/inputs/LabelInput.component";
import { AuthContext } from "webContext/Auth.context";
import CustomButton from "../form-elements/inputs/CustomButton.component";

const classes = StyleSheet.create({
  root: {
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  imageContainer: {
    width: "100%",
    alignItems: "center",
  },
  logoImage: {
    width: "100%",
    height: "250px",
  },
  bgImage: {
    position: "absolute",
    opacity: 0.9,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  card: {
    alignSelf: "flex-end",
    backgroundColor: "rgba(49, 120, 170, 1)",
    borderLeftColor: "rgb(110, 182, 234)",
    borderLeftWidth: 2,
    height: "100%",
    minWidth: "500px",
    width: "20%",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  headerText: {
    fontSize: 28,
    fontWeight: theme.font.weight.medium,
    color: theme.color.white,
  },
  titleText: {
    fontSize: 28,
    fontWeight: theme.font.weight.medium,
    color: theme.color.white,
  },
  inputContainer: {
    width: "65%",
    alignItems: "center",
    justifyContent: "center",
    height: "10%",
    gap: 16,
  },
  headerContainer: {
    marginBottom: 8,
    height: "100%",
    width: "80%",
    alignItems: "center",
  },
  buttonContainer: {
    paddingTop: 50,
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
    width: "100%",
  },
  button: {
    alignSelf: "center",
    width: "80%",
  },
});

export default function Login() {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const { showToast } = useContext(ToastContext);
  const width = useWindowDimensions().width;
  const handleLoginPress = async () => {
    try {
      const res = await AuthService.getAuthOrganizations(email, password, true);

      if (res?.payload?.length) {
        if (res.payload.length === 1) {
          await login(email, password, res.payload[0].organizationId);
          return;
        }
        setOrganizations(res.payload);
        setModalVisible(true);
      } else {
        // email not found
        if (__DEV__) {
          console.error("This email does not exist in the database");
        }
        showToast("Invalid credentials were provided to the client.", "error");
      }
    } catch (err) {
      if (__DEV__) {
        console.error("Login Error: ", err);
      }
      if (err?.response?.status === 429) {
        // Rate limit exceeded
        const msg =
          err.response.data?.message ||
          "Too many login attempts, please try again later.";
        showToast(msg, "error");
      } else {
        showToast("Invalid credentials were provided to the client.", "error");
      }
    }
  };
  const handleSelectOrg = async (org) => {
    setModalVisible(false);
    await login(email, password, org.organizationId);
  };

  const stateClasses = StyleSheet.create({
    card: {
      ...classes.card,
      ...(width <= 500
        ? {
            alignSelf: "center",
            width: "100%",
            minWidth: "auto",
          }
        : {
            alignSelf: "flex-end",
          }),
    },
  });

  return (
    <View style={classes.root}>
      <Image source={background} resizeMode="cover" style={classes.bgImage} />
      <View style={stateClasses.card}>
        <Overlay />
        <View style={classes.inputContainer}>
          <Text style={classes.titleText}>Business Continuity Plan</Text>
          <Text style={classes.headerText}>Admin Login</Text>
          <View style={classes.headerContainer} />
          <LabelInput
            variant="white"
            label="Email"
            required
            value={email}
            onChangeText={setEmail}
          />
          <LabelInput
            variant="white"
            required
            label="Password"
            isPassword
            value={password}
            onChangeText={setPassword}
            onSubmitEditing={handleLoginPress}
          />
          <CustomLink
            linkText="Forgot Password?"
            variant="white"
            navigateTo={SCREEN_ADMIN_FORGOT}
          />
          <CustomLink
            linkText="Privacy Policy"
            variant="white"
            navigateTo={SCREEN_PRIVACY}
          />

          <View style={classes.buttonContainer}>
            <CustomButton
              styleOverride={classes.button}
              title="Login"
              variant="dark"
              onPress={handleLoginPress}
            />
            <CustomLink
              linkText="Don't have an account? Register here."
              variant="white"
              navigateTo={SCREEN_ADMIN_REGISTER}
            />
          </View>
        </View>
      </View>

      <SelectOrganizationModal
        visible={modalVisible}
        organizations={organizations}
        onSelect={handleSelectOrg}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
}
